import React, { Component } from 'react';
import globals from "../globals";
import ProductDetails from "../modules/ProductDetails";
import RegisterBlock from "../modules/RegisterBlock";
import VoiceDidTable from "../modules/VoiceDidTable";
import VoicePortabilityTable from "../modules/VoicePortabilityTable";
import VoiceRegister from "../modules/VoiceRegister";
import Table from "../modules/Table";
import OutageGuarantee from "../modules/OutageGuarantee";
import HelmetDefault from "../layout/HelmetDefault";
import Hero from "../modules/Hero/Hero";
import BasicList from "../modules/BasicList";

class BusinessVoip extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            subTitle: '',
			leadCopy: [],
            product: {
                details: {
                    leadCopy: []
                },
				features: [],
				price: ''
            },
            plans: {
                plan: {
                    list: []
                }
            },
            serviceAgreement: {},
            seoTitle: '',
            seoDescription: '',
			dataReceived: false
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        fetch('/api/voip/business')
            .then(result => result.json())
            .then((result) => {
                this.setState(result);
                this.setDataReceived();
                globals.animatePageIn(this.container);
            });
    }

	setDataReceived() {
		this.setState({
			dataReceived: true
		});
	}

    render() {
        return (
            <div ref={(el) => this.container = el} style={{opacity: 0}}>
                <HelmetDefault {...this.state} />
				<Hero title={this.state.title} subTitle={this.state.subTitle} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived} />
                <ProductDetails product={this.state.product} bottomWave="bottom-wave-darkgreen">
                    <div className="row">
						<div className="price">{this.state.product.price}</div>
						<BasicList list={this.state.product.features} />
                    </div>
                    <VoiceRegister />
                    <div className="row table-container">
                        <div className="col-md-8 col-md-offset-2 col-xs-12">
                            <VoiceDidTable />
                            <VoicePortabilityTable />
                            <div className="row">
                                <div className="col-md-10 col-md-offset-1 col-xs-12 centered">
                                    <p># Category C: Complex ports that require a resubmission due to incorrect Wholesale Account Number or Incorrect Details as provided by the customer, are subject to resubmission Port-in-Fee</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </ProductDetails>
                <Table data={this.state.serviceAgreement} image="" />
                <OutageGuarantee />
                <RegisterBlock />
            </div>
        );
    }

}

export default BusinessVoip;


// WEBPACK FOOTER //
// ./resources/assets/js/voip/BusinessVoip.js